<i class="c-favorite-icon" [style.font-size.px]="size" [ngClass]="isFavorite ? 'icon-star-full': 'icon-star'"></i>
